var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.2C2 2.53726 2.53726 2 3.2 2H5.6C6.26274 2 6.8 2.53726 6.8 3.2V5.6C6.8 6.26274 6.26274 6.8 5.6 6.8H3.2C2.53726 6.8 2 6.26274 2 5.6V3.2Z",
    stroke: "#133696",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 10.4C9.2 9.73726 9.73726 9.2 10.4 9.2H12.8C13.4627 9.2 14 9.73726 14 10.4V12.8C14 13.4627 13.4627 14 12.8 14H10.4C9.73726 14 9.2 13.4627 9.2 12.8V10.4Z",
    stroke: "#133696",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 3.2C9.2 2.53726 9.73726 2 10.4 2H12.8C13.4627 2 14 2.53726 14 3.2V5.6C14 6.26274 13.4627 6.8 12.8 6.8H10.4C9.73726 6.8 9.2 6.26274 9.2 5.6V3.2Z",
    stroke: "#133696",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.4C2 9.73726 2.53726 9.2 3.2 9.2H5.6C6.26274 9.2 6.8 9.73726 6.8 10.4V12.8C6.8 13.4627 6.26274 14 5.6 14H3.2C2.53726 14 2 13.4627 2 12.8V10.4Z",
    stroke: "#133696",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDashboard);
export default __webpack_public_path__ + "static/media/activeDashboard.196d32415520d1c7659e0151676283fe.svg";
export { ForwardRef as ReactComponent };